import { useFormContext } from 'react-hook-form'

import useInputOnAutoSubmit from './useInputOnAutoSubmit'
import useIsDisabled from './useIsDisabled'
import { InputCheckboxProps } from '../interfaces'

export default function useInputCheckbox(props: InputCheckboxProps) {
  /**
   * NOTE: This is also use by InputRadio!
   */

  const { id, name, value } = props
  const ctx = useFormContext()
  const elemId = id ? id : `id_${name}`
  const isDisabled = useIsDisabled(props)
  const { canAutoSubmit, onSubmit } = useInputOnAutoSubmit(props)

  const watch = ctx.watch(name)

  let isChecked = false
  if (Array.isArray(watch)) {
    watch.forEach((item: string) => {
      if (item === value) {
        isChecked = true
      }
    })
  } else {
    if (watch === value || watch === true) {
      isChecked = true
    }
  }

  return {
    ctx,
    elemId,
    isDisabled,
    isChecked,
    canAutoSubmit,
    onSubmit,
  }
}
